<template>
  <svg
    preserveAspectRation="none"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.0049 14.0024C22.0049 9.58281 18.4221 6 14.0024 6C13.4501 6 13.0024 5.55228 13.0024 5C13.0024 4.44772 13.4501 4 14.0024 4C19.5266 4 24.0049 8.47824 24.0049 14.0024C24.0049 19.5266 19.5266 24.0049 14.0024 24.0049C8.47824 24.0049 4 19.5266 4 14.0024C4 13.4501 4.44772 13.0024 5 13.0024C5.55228 13.0024 6 13.4501 6 14.0024C6 18.4221 9.58281 22.0049 14.0024 22.0049C18.4221 22.0049 22.0049 18.4221 22.0049 14.0024Z"
      fill="CurrentColor"
    />
  </svg>
</template>
